// extracted by mini-css-extract-plugin
module.exports = {"offlineIcon":"status-badge_offlineIcon__1nq63","statusBadge":"status-badge_statusBadge__GUYuu"};